/**
 * Recases fully-uppercase filter labels ("GENERATION", "ETHNICITY - US") for
 * display. Tokens under four letters stay as-is — at that length caps are more
 * likely an acronym (US, EU, NPS, USA) than a shouted word.
 */
export const displayCase = (name: string): string => {
  if (!/[A-Z]/.test(name) || name !== name.toUpperCase()) return name;
  return name
    .split(/(\s+)/)
    .map((token) =>
      /^[A-Z]{4,}$/.test(token)
        ? token.charAt(0) + token.slice(1).toLowerCase()
        : token,
    )
    .join("");
};
